<template>
  <div>
    <div class="mb-1">
      <v-breadcrumbs
        class="px-0"
        :items="[{ title: '園児・保護者情報', href: '/children', color: 'primary', disabled: false },
        {title: `${child?.lastName } ${ child?.firstName }`,disabled: true}]"
      >
      </v-breadcrumbs>
    </div>
    <div class="d-flex align-center">
      <h1 v-if="child"> {{ child.lastName }} {{ child.firstName }} </h1>
      <v-spacer></v-spacer>
      <v-btn
        size="x-large"
        variant="flat"
        color="primary"
        @click="save"
        :disabled="isSaving"
      >保存</v-btn>
    </div>
    
    <div>
      <v-progress-linear
        v-if="isSaving || loading"
        indeterminate
        color="primary"
        class="my-8"
      ></v-progress-linear>
    </div>

    <v-tabs v-model="tab" color="primary">
      <v-tab value="1">基本情報</v-tab>
      <v-tab value="2">生活情報</v-tab>
      <v-tab value="3">健康・発育情報</v-tab>
    </v-tabs>

    <v-window v-model="tab">
      <v-window-item value="1">
        <child-info-page
          :elements="basicInfo"
          @update-info="updateBasicInfo"
        ></child-info-page>
      </v-window-item>

      <v-window-item value="2">
        <child-info-page
          :elements="lifeStyleInfo"
          @update-info="updateLifestyleInfo"
        ></child-info-page>
      </v-window-item>
      
      <v-window-item value="3">
        <child-info-page
          :elements="healthInfo"
          @update-info="updateHealthInfo"
        ></child-info-page>
      </v-window-item>
    </v-window>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { childDocumentModule } from  '@/store/dataModules/childDocumentModule';
import { ChildInfoData } from 'chaild-api/lib';

import ChildInfoPage from '@/components/organisms/ChildInfoPage.vue';

interface DataType {
  tab: string; // 💡 Vuetify 3 の v-window は value を string で持つのが安全です
  childId: number | null;
  isSaving: boolean;
  loading: boolean;
}

export default defineComponent({
  components: {
    ChildInfoPage,
  },

  data: (): DataType => {
    return {
      tab: "1", // 💡 初期値を文字列の "1" に変更
      childId: null,
      isSaving: false,
      loading: false,
    };
  },

  computed: {
    doc() {
      // ⚠️ 以前の修正と同様、もしStoreオブジェクトをVuex4仕様に書き換えている場合は
      // (this as any).$store.state.childDocument.doc のような形に修正が必要です
      return childDocumentModule.doc;
    },
    child() {
      return childDocumentModule.child;
    },
    basicInfo(): ChildInfoData[] {
      if (this.doc) {
        return this.doc.basicInfo;
      }
      return [];
    },
    lifeStyleInfo(): ChildInfoData[] {
      if (this.doc) {
        return this.doc.lifestyleInfo;
      }
      return [];
    },
    healthInfo(): ChildInfoData[] {
      if (this.doc) {
        return this.doc.healthInfo;
      }
      return [];
    },
  },

  methods: {
    updateBasicInfo(value: ChildInfoData) {
      childDocumentModule.updateBasicInfo(value);
      childDocumentModule.updateDataToUpdate(value);
    },
    updateLifestyleInfo(value: ChildInfoData) {
      childDocumentModule.updateLifestyleInfo(value);
      childDocumentModule.updateDataToUpdate(value);
    },
    updateHealthInfo(value: ChildInfoData) {
      childDocumentModule.updateHealthInfo(value);
      childDocumentModule.updateDataToUpdate(value);
    },
    async save() {
      this.isSaving = true;
      await childDocumentModule.saveUpdates();
      this.isSaving = false;
    }
  },
  
  async mounted() {
    this.loading = true;

    const childId = this.$route.params.childId as string;
    if (childId) {
      try {
        childDocumentModule.clearLocalData()
        const parsed = parseInt(childId);
        childDocumentModule.setChildId(parsed);
        await childDocumentModule.getChildInfo();
        await childDocumentModule.getChild();
      } catch {
        return;
      }
    }
    this.loading = false;
  }
});
</script>